import { Injectable } from '@angular/core';
import { ReasonModel } from './model/reason.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReasonService {

  constructor(private http: HttpClient) { }

  getReasonList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/reason/get', requestData);
  }

  getReasonById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/reason/get/' + id, '');
  }

  update(reasonInfo: ReasonModel): Observable<any> {
    if (reasonInfo.hasOwnProperty("id") && reasonInfo.id && reasonInfo.id !== 0) {
      return this.http.post(environment.baseUrl + '/' + environment.app + '/reason/update', reasonInfo);
    } else {
      return this.http.post(environment.baseUrl + '/' + environment.app + '/reason/add', reasonInfo);
    }
  }

  delete(reasonInfo: ReasonModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/reason/delete/' + reasonInfo.id, reasonInfo);
  }
}
